import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { Switch } from "@tracify/ui/switch";
import { Tooltip, TooltipContent, TooltipTrigger } from "@tracify/ui/tooltip";
import type { ReactNode } from "react";

type Props = {
  tooltipContent?: ReactNode;
  checked: boolean;
  disabled?: boolean;
  onCheckedChange: (checked: boolean) => void;
  helperText?: ReactNode;
  inlineTrailingContent?: ReactNode;
};

const switchClassName =
  "!w-8 !h-4 !rounded-lg !border-[1px] !p-0.5 data-[state=unchecked]:border-border data-[state=unchecked]:bg-muted dark:data-[state=unchecked]:border-[#39394B] dark:data-[state=unchecked]:bg-[#1E1E29] data-[state=checked]:border-green-500 data-[state=checked]:bg-green-100 dark:data-[state=checked]:border-[#22C55E] dark:data-[state=checked]:bg-[#1B3A2A]";

const switchThumbClassName =
  "h-3 w-3 !rounded-lg data-[state=unchecked]:bg-background data-[state=unchecked]:shadow-sm data-[state=unchecked]:translate-x-0 dark:data-[state=unchecked]:bg-[#D5D5D8] data-[state=checked]:bg-green-500 data-[state=checked]:translate-x-[15px]";

const AdAccountPostbackControl = ({
  tooltipContent,
  checked,
  disabled = false,
  onCheckedChange,
  helperText,
  inlineTrailingContent,
}: Props) => {
  return (
    <div className="rounded-lg border border-primary-300/50 bg-primary-300/10 p-4">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="space-y-1">
          <div className="flex items-center gap-2">
            <p className="text-sm font-semibold text-foreground">
              Enable conversion postback
            </p>
            {tooltipContent ? (
              <Tooltip>
                <TooltipTrigger>
                  <InformationCircleIcon className="h-4 w-4 text-muted-foreground hover:text-foreground transition-colors" />
                </TooltipTrigger>
                <TooltipContent>{tooltipContent}</TooltipContent>
              </Tooltip>
            ) : null}
          </div>
          {helperText ? (
            <p className="max-w-3xl text-sm text-muted-foreground">
              {helperText}
            </p>
          ) : null}
        </div>
        <div className="flex items-center gap-2 sm:pt-0.5">
          <Switch
            disabled={disabled}
            checked={checked}
            onCheckedChange={onCheckedChange}
            className={switchClassName}
            thumbClassName={switchThumbClassName}
          />
          {inlineTrailingContent}
        </div>
      </div>
    </div>
  );
};

export default AdAccountPostbackControl;
